import { useState } from "react";
import { useCreatorCashContext } from "../../../context/CreatorCashProvider";
import "./FAQ.css";
import FadeInSection from "../../FadeInComponent/FadeInComponent";

export default function FAQ() {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const { state } = useCreatorCashContext();
    const faq = state?.faq;

    const handleClick = (index) => {
        setSelectedIndex((prev) => (prev === index ? null : index));
    };

    return (
        <div className="faq-container">
            <FadeInSection>
                <div className="faq-title">FAQ</div>
            </FadeInSection>
            <FadeInSection className="faq-ctr">
                {faq?.questions?.map((question, index) => {
                    const isSelected = selectedIndex === index;
                    return (
                        <div
                            key={index}
                            className={`faq cursor-pointer ${isSelected ? "selected-faq" : (selectedIndex - 1 !== index) ? "not-selected-faq" : ''}`}
                            onClick={() => handleClick(index)}
                        >
                            <div className="question">
                                <div className="faq-question-text">{question?.question}</div>
                                <div className={isSelected ? "plus faqselected" : "plus"}></div>
                            </div>

                            {/* Keep div always rendered for transition */}
                            <div className={`faq-answer-wrapper ${isSelected ? "open" : ""}`}>
                                <div className="faq-answer">{question?.answer || "-"}</div>
                            </div>
                        </div>
                    );
                })}
            </FadeInSection>
        </div>
    );
}
